<template>
	<div style="height: 80vh">
		Historia clínica
	</div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/TestPaciente.vue